import React, { useContext, useEffect, useState } from 'react';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import Picture from '../../components/ui/Picture/Picture';
import { Image } from '../../types/components';
import { useGetProductImagesQuery } from '../../redux-modules/service';
import ProductContext from '../../contexts/ProductContext';

export default function ImageSlider({
  selectedColor,
  type = 'full',
}: {
  selectedColor: string;
  type: 'full' | 'small',
}) {
  const { product } = useContext(ProductContext);
  const [width, setWidth] = useState(window.innerWidth);

  const { data: images, isLoading, isFetching } = useGetProductImagesQuery({
    product: product.id,
    color: encodeURIComponent(selectedColor),
    type,
  });

  useEffect(() => {
    const handleResize = () => ((width >= 1024 && window.innerWidth < 1024)
    || (width < 1024 && window.innerWidth >= 1024) ? setWidth(window.innerWidth) : null);
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
  }, [width]);

  if (isLoading || isFetching || (images === undefined || images.length === 0)) {
    return <div className="min-h-svh" />;
  }

  if (width >= 1024) {
    return (
      <div className="product-swiper lg:px-6 xl:px-11.7 lg:pt-8 xl:pt-12">
        <div className="swiper">
          <div className="swiper-wrapper lg:flex-col lg:gap-y-16 xl:gap-y-24">
            {images.map((image: Image, index: number) => (
              <div key={image.title} className="swiper-slide lg:h-auto bg-product-slide bg-white mb-2.5 lg:py-0">
                <Picture image={image} loading={index === 0 ? 'eager' : 'lazy'} pictureClasses="block w-full rounded-lg lg:rounded-none px-7.5 lg:px-0" classes="w-full" />
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="product-swiper lg:px-6 xl:px-11.7 lg:pt-8 xl:pt-12">
      <Swiper
        wrapperClass="lg:flex-col lg:gap-y-16 xl:gap-y-24"
        modules={[Pagination]}
        grabCursor
        spaceBetween={16}
        slidesPerView={1}
        autoHeight
        pagination={{
          el: '.swiper-pagination',
          clickable: true,
        }}
      >
        {images.map((image: Image, index: number) => (
          <SwiperSlide
            key={image.title}
            className="swiper-slide lg:h-auto bg-product-slide bg-white mb-2.5 lg:py-0"
          >
            <Picture image={image} loading={index === 0 ? 'eager' : 'lazy'} pictureClasses="block w-full rounded-lg lg:rounded-none lg:px-0" classes="w-full" />
          </SwiperSlide>
        ))}
      </Swiper>
      {Object.values(images).length > 1 && (
        <div className="swiper-pagination pt-6 pb-3 lg:hidden top-0" />
      )}
    </div>
  );
}
